

export const getDropdownData = (entityLovs: any[], key) => entityLovs?.filter((lov) => lov.key === key) ?? []
export const getAdditionalDocCategory = (entityLovs: any[], key) =>
  entityLovs?.filter((lov) => lov.key === key && !['POA', 'POI', 'POB', 'CC', 'FS', 'RISK'].includes(lov.value))
export const getBankDocCategory = (entityLovs: any[], key) =>
  entityLovs?.filter((lov) => lov.key === key && ['FS', 'CC'].includes(lov.value))

export const allowParentFeePackageId = [
  { id: 1, value: 'Yes' },
  { id: 2, value: 'No' },
  // Add other options as needed
]

export const allowRiskTip = [
  { id: 1, value: 'Yes' },
  { id: 2, value: 'No' },
  // Add other options as needed
]


export const merchantRiskCategoary = [
  { id: 1, value: 'TRUSTED' },
  { id: 2, value: 'NON-TRUSTED' },
  // Add other options as needed
]

export const allowParentIdSettlement = [
  { id: 1, value: 'Yes' },
  { id: 2, value: 'No' },
  // Add other options as needed
]
